export default {
  name: "lucky"
};